import { gql } from '@apollo/client';

// The legacy GET /ceramics/:id/similarities.json view, folded into GraphQL
// (BUN_PLAN §6, P6.5): the publication's ceramics joined with the stored
// BOVW similarity matrix, sorted by similarity desc.
export const CERAMIC_SIMILARITIES_QUERY = gql`
  query CeramicSimilarities($id: ID!) {
    ceramicSimilarities(id: $id) {
      ceramic {
        id
        identifier
        type
        probability
        pageNumber
        site { id name }
      }
      publication {
        id
        title
        author
      }
      totalSimilar
      maxSimilarity
      similarities {
        id
        identifier
        type
        probability
        similarity
        pageNumber
        site { id name }
      }
    }
  }
`;
